import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import { IGenericDTO, IInlineEditingContextDTO, IResultDTO } from "coreframetypings/dto";
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import DisconnectLinkViewModel from '@/Components/Links/DisconnectLink/DisconnectLinkViewModel';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import Utilities from '@/Utility/Utilities';

export default class ExtIEGDisconnectLinkViewModel extends DisconnectLinkViewModel {

    /**
     * If set to true, there is a warning on deletion
     */
    public showDeletionWarningOnDisconnect: boolean;

    /**
     * The current inline editing context
     */
    private inlineEditingContext: KnockoutObservable<IInlineEditingContextDTO>;

    public constructor(params: any) {
        super(params);
        this.showDeletionWarningOnDisconnect = this.paramOrDefault(params.showDeletionWarningOnDisconnect, true);
        this.inlineEditingContext = this.observableOrDefault(params.inlineEditingContext, null);
    }

    /**
     * @override
     */
    protected createIsVisibleObservable(): KnockoutObservable<boolean> {
        this.setRequiredObservables();

        return this.createWritableComputed(() => !this.params.context?.isSummaryViewMode() && this.listView().showButtonDisconnect);
    }

    /**
     * @override
     */
    protected tryToDisconnect(pdoId: string, associationName: string, topdTypeName: string, toPdoIds: Array<string>, nestedContextName: string): JQueryPromise<boolean> {
        if (this.showDeletionWarningOnDisconnect) {
            let deferred = $.Deferred<boolean>();
            const messageBox = MessageBoxViewModel.createDeletionMessageBox(false, () => deferred.resolve(true), () => deferred.resolve(false));
            RADApplication.getInstance().showMessageBox(messageBox);

            return deferred.promise();
        }
        else {
            return Utilities.resolveImmediately(true);
        }
    }

    /**
     * @override
     */
    protected callDisconnectOperation(pdoId: string, associationName: string, topdTypeName: string, toPdoIds: Array<string>, nestedContextName: string): JQueryPromise<IResultDTO> {
        return RADEnvironmentProxy.getInstance().disconnectFromInlineEditing({
            inlineEditingContextId: this.inlineEditingContext()?.id,
            targetPdoIds: toPdoIds.map(pdoID => parseInt(pdoID)),
            targetPdTypeName: topdTypeName,
        }).promise();
    }

    /**
     * @override
     */
    protected getPdoIds(rows: IGenericDTO[]): string[] {
        return rows.map(x => x.pdoId);
    }
}

ComponentManager.setViewModel('ExtIEGDisconnectLink', ExtIEGDisconnectLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');